const MapElementModel = {
  latitude: '',
  longitude: '',
  zoom: 16,
  address: { pl: '', en: '' },
};

export default MapElementModel;
